import { Model } from '@/models/Model';
import { SupplierSize } from '@/models/SupplierSize';
import ErrorHandler from '@/support/ErrorHandler';
import _, { cloneDeep, isArray, isObject, map } from 'lodash';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

@Component<SupplierSizeAutocomplete>({})
export default class SupplierSizeAutocomplete extends Vue {

  // #region @VModel
  // #endregion

  // #region @PropSyncs
  // #endregion

  // #region @Props

  @Prop({ default: 'Supplier size(s)' })
  protected label!: string;

  @Prop({ default: () => new SupplierSize() })
  protected model!: SupplierSize;

  @Prop({ default: 'Supplier size(s)' })
  protected placeholder!: string;

  protected items: SupplierSize[] = [];

  protected originalSortOrderItems!: SupplierSize[];

  protected searchInput = '';

  protected async created(): Promise<void> {
    await this.onCreated();
  }

  protected async onCreated(): Promise<void> {
    this.originalSortOrderItems = await this.model.autocomplete(); // This will fetch all the items

    this.$set(this, 'items', this.groupItemsByValue(cloneDeep(this.originalSortOrderItems), this.$attrs.value));
  }

  protected groupItemsByValue(items: SupplierSize[], value: AInputableSelect<SupplierSize> | AInputableSelect<SupplierSize>[]): SupplierSize[] {
    let values: string[] = [];

    if (isArray(value)) {
      values = value.map((val) => isObject(val) ? (val as SupplierSize).id as string : val as string);
    } else {
      values = [isObject(value) ? (value as SupplierSize).id as string : value as string];
    }

    return items ? [
      ...items.filter((item) => item && values.includes(item.id as string)),
      ...items.filter((item) => item && ! values.includes(item.id as string)),
    ] : [];
  }

  // #endregion

  // #region @Refs
  // #endregion

  // #region Props
  // #endregion

  // #region Plugin props
  // #endregion

  // #region Lifecycle hooks / Init
  // #endregion

  // #region Handlers
  // #endregion

  // #region Helpers
  // #endregion

  // #region API Requests
  // #endregion

  // #region Getters & Setters
  // #endregion

  // #region @Watchers

  protected onInput(newValue: SupplierSize[]): void {
    this.$set(this, 'items', this.groupItemsByValue(cloneDeep(this.originalSortOrderItems), newValue));
    this.searchInput = '';
    this.$emit('input', newValue);
  }

  @Watch('$attrs', { deep: true })
  protected valueChanged(newValue: AInputableSelect<SupplierSize> | AInputableSelect<SupplierSize>[]): void {
    this.$set(this, 'items', this.groupItemsByValue(cloneDeep(this.originalSortOrderItems), newValue));
  }

  // #endregion
}

export type AInputableSelect<TModel extends Model> = TModel | Record<string, unknown> | string | number | boolean
